import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TenantsListPageDto } from 'app/api/models/tenant/tenantsListPageDto';
import { MessageText, ToastService } from 'app/helpers/services/toastService';
import { SortProperty } from 'app/interfaces/sort-property';
import { AuthRepository } from 'app/state/auth.repository';
import { IConfirm, Tenant } from 'app/state/tenants.repository';
import { TenantsService } from 'app/state/tenants.service';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrls: ['./tenant-list.component.scss'],
})
export class TenantListComponent implements OnInit {
  @Input() innerWidth = 0;
  @Input() set tenants(items: TenantsListPageDto[]) {
    this.initTenants = items;
  }
  @Input() isDeleteDisabled = true;
  @Output() delete = new EventEmitter<string>();
  @Output() clone = new EventEmitter<IConfirm>();
  deleteConfirmation: TenantsListPageDto | null = null;
  cloneConfirmation: TenantsListPageDto | null = null;
  initTenants: TenantsListPageDto[] = [];
  showDialogSP = false;
  tenantId = '';
  descriptions: any[] = [];

  constructor(public auth: AuthRepository, private http: HttpClient) {}

  ngOnInit(): void {}

  handleDeleteClick(tenant: TenantsListPageDto) {
    if (!this.isDeleteDisabled) {
      this.delete.emit(tenant.id);
    }
  }

  onGlobalFilter(table: Table, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    table.filterGlobal(inputElement.value, 'contains');
  }

  showSPmodal(tenantId: string) {
    this.tenantId = tenantId;

    this.http
      .get(`/api/tenants/spdescriptions/${this.tenantId}`)
      .subscribe((x: any) => {
        if (x) {
          this.selectedCategories.forEach((element) => {
            const t = x.find((f: any) => f.key == element.key);
            if (t) {
              element.description = t.description;
            }
          });
          this.selectedCategoriesDepartment.forEach((element) => {
            const t = x.find((f: any) => f.key == element.key);
            if (t) {
              element.description = t.description;
            }
          });
          this.selectedCategoriesOperational.forEach((element) => {
            const t = x.find((f: any) => f.key == element.key);
            if (t) {
              element.description = t.description;
            }
          });
        }
        this.showDialogSP = true;
      });
  }

  selectedCategories = [
    {
      key: '1.1',
      name: 'Value Proposition / Mission & Purpose',
      description: '',
    },
    { key: '1.1.1', name: 'Segmentation criteria', description: '' },
    { key: '1.1.2', name: 'Dream Customers & ICP', description: '' },
    {
      key: '1.1.3',
      name: 'Sales Philosophy & Preferred Method',
      description: '',
    },

    { key: '1.2', name: 'KPI Model & Commercial Dashboard', description: '' },
    { key: '1.2.1', name: 'Buying Journey Positioning', description: '' },
  ];

  selectedCategoriesDepartment = [
    {
      key: '2.1',
      name: 'The Customer Journey (Buying Journey Map)',
      description: '',
    },
    { key: '2.2', name: 'Sales Process (Activity-Based)', description: '' },

    { key: '2.3', name: 'Pipeline Management', description: '' },
    { key: '2.3.1', name: 'Handover New Biz → After Sales', description: '' },
    {
      key: '2.3.2',
      name: 'Account Plans: Land – Expand – Protect',
      description: '',
    },
    {
      key: '2.3.3',
      name: 'Personas & Stakeholder Motivations',
      description: '',
    },
  ];

  selectedCategoriesOperational = [
    { key: '3.1', name: 'Structure for Customer Meetings', description: '' },
    { key: '3.2', name: 'Objections Bank', description: '' },
    { key: '3.3', name: 'Argument Bank / Selling Points', description: '' },
    { key: '3.4', name: 'Phone Call Scripts', description: '' },
    {
      key: '3.5',
      name: 'Meeting Structure (before/during/after)',
      description: '',
    },
    {
      key: '3.6',
      name: 'Needs Discovery & Qualification Flow',
      description: '',
    },
  ];

  save() {
    this.http
      .post(
        `/api/tenants/spdescriptions/${this.tenantId}`,
        this.selectedCategories
          .concat(this.selectedCategoriesDepartment)
          .concat(this.selectedCategoriesOperational)
      )
      .subscribe((x) => {
        this.showDialogSP = false;

        this.selectedCategories.forEach((element) => {
          element.description = '';
        });
        this.selectedCategoriesDepartment.forEach((element) => {
          element.description = '';
        });
        this.selectedCategoriesOperational.forEach((element) => {
          element.description = '';
        });
      });
  }
}
